import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Utils from 'utils/Utils';

import './Info.css';

class Info extends Component {

  render() {
    const { t, variant, data } = this.props;
    let formattedDate = variant !== 'flight' ? Utils.formatDate(new Date(data.date)) : '';
    if (formattedDate.indexOf('01/01/') > -1) {
      formattedDate = formattedDate.replaceAll('01/01/', '');
    }

    return (
      <div className='infoModalContainer'>
        { variant === 'flight' ?
          <div className='infoFlight'>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Denominación'}
              </div>
              <div className='row attribute-value'>
                {data.title !== undefined ? data.title.replaceAll('.', '') : 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Fecha'}
              </div>
              <div className='row attribute-value'>
                {data.year_from && data.year_to ? (
                  data.year_from.split('-')[0] !== data.year_to.split('-')[0]
                    ? `${data.year_from.split('-')[0]} / ${data.year_to.split('-')[0]}`
                    : data.year_from.split('-')[0]
                ) : 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.scale')}
              </div>
              <div className='row attribute-value'>
                {data.scale ? data.scale.replace(/-/g, ', ').replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.color')}
              </div>
              <div className='row attribute-value'>
                {data.color || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.flight_type')}
              </div>
              <div className='row attribute-value'>
                {data.fly_type || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Número de fotogramas'}
              </div>
              <div className='row attribute-value'>
                {data.num_frames || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.flight_typologoy')}
              </div>
              <div className='row attribute-value'>
                {data.fly_typology || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Titular'}
              </div>
              <div className='row attribute-value'>
                {data.fly_owner || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Metadatos'}
              </div>
              <div className='row attribute-value'>
                { data.fly_metadata !== undefined && data.fly_metadata.indexOf('http') > -1 ?
                  <a href={data.fly_metadata} target='_blank' rel='noopener noreferrer'>{data.fly_metadata}</a>
                : 'Información no disponible' }
              </div>
            </div>
          </div>
          : <div className='infoFotogram'>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Denominación'}
              </div>
              <div className='row attribute-value'>
                {data.fly_title !== undefined ? data.fly_title.replaceAll('.', '') : 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.date')}
              </div>
              <div className='row attribute-value'>
                {formattedDate || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Sistema de Referencia'}
              </div>
              <div className='row attribute-value'>
                {data.ellipsoid !== undefined && data.utm_zone !== undefined ? `${data.ellipsoid} - ${data.utm_zone}N` : 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.scale')}
              </div>
              <div className='row attribute-value'>
                {data.scale.replace(/\B(?=(\d{3})+(?!\d))/g, '.') || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.flight_type')}
              </div>
              <div className='row attribute-value'>
                {data.fly_type || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.flight_typologoy')}
              </div>
              <div className='row attribute-value'>
                {data.fly_typology || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Titular'}
              </div>
              <div className='row attribute-value'>
                {data.fly_owner || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {'Metadatos'}
              </div>
              <div className='row attribute-value'>
                { data.fly_metadata !== undefined && data.fly_metadata.indexOf('http') > -1 ?
                  <a href={data.fly_metadata} target='_blank' rel='noopener noreferrer'>{data.fly_metadata}</a>
                : 'Información no disponible' }
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.municipality')}
              </div>
              <div className='row attribute-value'>
                {data.municipality || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.province')}
              </div>
              <div className='row attribute-value'>
                {data.province || 'Información no disponible'}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.sheet_50')}
              </div>
              <div className='row attribute-value'>
                {data.hoja_mtn_50 || 'Información no disponible'}
              </div>
            </div>
          </div>}
      </div>
    );
  }
}

export default translate()(Info);
